<template>
    <div>
        <fragment>
            <p class="mb-4 text-lg font-bold">Available: {{ customerCard | asCurrency }}</p>
            <p v-if="errorMessage" class="mt-2 font-bold text-red-500">Error: {{ errorMessage }}</p>
        </fragment>
    </div>
</template>

<script>
    import Dinero from 'dinero.js';
    import { Fragment } from 'vue-fragment';
    import asCurrency from '@/filters/asCurrency';

    export default {
        name: 'CustomerCard',
        components: {
            Fragment,
        },
        filters: {
            asCurrency,
        },
        mixins: [],
        props: {
            value: {
                required: true,
                type: [Number, String],
            },
            customer: {
                required: true,
                type: Object,
            },
            payments: {
                required: true,
                type: Array,
            },
            canSubmit: {
                required: true,
                type: Boolean,
            },
            payment: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                errorMessage: '',
            };
        },
        computed: {
            customerCard() {
                return new Dinero(this.customer.card)
                    .subtract(this.payments.filter((payment) => payment.type === 'CustomerCard').reduce((carry, payment) => carry.add(new Dinero(payment.amount)), new Dinero()))
                    .toObject();
            },
        },
        watch: {
            payment: {
                handler() {
                    if (new Dinero(this.customerCard).greaterThanOrEqual(new Dinero(this.payment.amount))) {
                        this.errorMessage = '';
                        this.$emit('valid', {
                            fieldName: 'amount',
                            valid: true,
                            message: this.errorMessage,
                        });
                    } else {
                        this.errorMessage = 'Cannot tender more than the card has loaded.';
                        this.$emit('invalid', {
                            fieldName: 'amount',
                            valid: false,
                            message: this.errorMessage,
                        });
                    }
                },
                deep: true,
                immediate: true,
            },
            canSubmit(value) {
                if (value) {
                    this.$emit('submit');
                }
            },
        },
        created() {
            this.$emit('balance', this.customerCard);
            if (new Dinero(this.customerCard).greaterThanOrEqual(new Dinero(this.payment.amount))) {
                this.errorMessage = '';
                this.$emit('valid', {
                    fieldName: 'amount',
                    valid: true,
                    message: this.errorMessage,
                });
            }
        },
        methods: {},
    };
</script>
